// Feature flags read from .env at build/start time (restart `npm start` after changing them).
// Hidden unless explicitly set to "true".
export const SHOW_METRICS = process.env.REACT_APP_SHOW_METRICS === 'true';
